import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

export const OssActionProcessDialog = ({ open, item, loading, onClose, onSubmit }) => {
  const [note, setNote] = useState("");
  const [mode, setMode] = useState("DONE");
  const [nextCheckDate, setNextCheckDate] = useState("");

  useEffect(() => {
    if (open) {
      setNote("");
      setMode("DONE");
      setNextCheckDate("");
    }
  }, [open]);

  if (!item) return null;
  const isFollowUp = mode === "FOLLOW_UP";
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowValue = new Date(tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const submitDisabled = loading || (isFollowUp && (!nextCheckDate || !note.trim()));
  const modeOptions = [
    {
      value: "DONE",
      label: "완료 처리",
      helper: "확인 결과를 남기고 조치 필요 목록에서 제외합니다.",
    },
    {
      value: "FOLLOW_UP",
      label: "다시 확인 예약",
      helper: "선택한 다음 확인일에 조치 필요 목록에 다시 표시합니다.",
    },
  ];

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ px: "24px !important", py: "18px !important", fontSize: "19px !important", fontWeight: "800 !important", borderBottom: "1px solid #e5e7eb" }}>
        조치 처리
      </DialogTitle>
      <DialogContent sx={{ p: "20px 24px !important", bgcolor: "#f8fafc" }}>
        <Stack spacing={1.45}>
          <Box sx={{ p: 1.6, border: "1px solid #e5e7eb", borderRadius: "8px", bgcolor: "#fff" }}>
            <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: "#111827" }}>
              {item.exception_title}
            </Typography>
            <Typography sx={{ mt: 0.25, fontSize: 12.5, color: "#64748b" }}>
              {item.order_no} · {item.item_name_snapshot}
            </Typography>
          </Box>
          <RadioGroup
            value={mode}
            onChange={(event) => setMode(event.target.value)}
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
              gap: 1,
              "& .MuiFormControlLabel-label": { fontSize: 13.5, color: "#374151" },
            }}
          >
            {modeOptions.map((option) => {
              const selected = mode === option.value;
              return (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio size="small" />}
                  sx={{
                    m: 0,
                    px: 1.3,
                    py: 1.1,
                    alignItems: "flex-start",
                    border: `1px solid ${selected ? "#6c5ce7" : "#e5e7eb"}`,
                    borderRadius: "8px",
                    bgcolor: selected ? "#f5f3ff" : "#fff",
                  }}
                  label={
                    <Box>
                      <Typography sx={{ fontSize: 13.8, fontWeight: "900 !important", color: "#111827" }}>
                        {option.label}
                      </Typography>
                      <Typography sx={{ mt: 0.25, fontSize: 12.3, color: "#64748b", lineHeight: 1.35 }}>
                        {option.helper}
                      </Typography>
                    </Box>
                  }
                />
              );
            })}
          </RadioGroup>
          {isFollowUp && (
            <TextField
              label="다음 확인일"
              type="date"
              value={nextCheckDate}
              onChange={(event) => setNextCheckDate(event.target.value)}
              size="small"
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: tomorrowValue }}
              helperText="내일 이후 날짜만 선택할 수 있습니다."
            />
          )}
          <TextField
            label="조치 메모"
            value={note}
            onChange={(event) => setNote(event.target.value)}
            multiline
            minRows={3}
            placeholder={isFollowUp ? "현재 확인 내용과 다시 확인해야 하는 이유를 입력" : "확인 결과와 처리 내용을 입력"}
            required={isFollowUp}
            helperText={isFollowUp ? "다시 확인 예약 시 메모는 필수입니다." : "메모를 입력하면 조치 이력에 남습니다."}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.6, borderTop: "1px solid #e5e7eb" }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>취소</Button>
        <Button
          variant="contained"
          disabled={submitDisabled}
          onClick={() =>
            onSubmit({
              actionStatus: isFollowUp ? "IN_PROGRESS" : "DONE",
              resultNote: note || (isFollowUp ? `${item.exception_title} 재확인 예약` : `${item.exception_title} 완료 처리`),
              nextCheckDate: isFollowUp ? nextCheckDate : undefined,
              checkResult: isFollowUp ? "UNDECIDED" : "ON_SCHEDULE",
            })
          }
        >
          {isFollowUp ? "다시 확인 예약" : "완료 처리"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
